//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Layouts */
export const Layout = {
    /** Gets the Left Sidebar layout (Checkin Manager Site) */
    CheckinManagerLeftSidebar: "2669A579-48A5-4160-88EA-C3A10024E1E1",
    /** Gets the Full Width layout (External Site) */
    FullWidth: "5FEAF34C-7FB6-4A11-8A1E-C452EC7849BD",
    /** Gets the Full Width layout (Internal Site) */
    FullWidthInternalSite: "D65F783D-87A9-4CC9-8110-E83466A0EADB",
    /** Gets the Left Sidebar layout (Internal Site) */
    LeftSidebar: "325B7BFD-8B80-44FD-A951-4E4763DA6C0D",
    /** Gets the Person Detail layout (Internal Site) */
    PersonDetail: "F66758C6-3E3D-4598-AF4C-B317047B5987",
    /** The Person Profile Detail layout GUID (Internal Site) */
    PersonProfileDetail: "6AD84AFC-B3A1-4E30-B53B-C6E57B513839",
    /** The Person Profile Home layout GUID (Internal Site) */
    PersonProfileHome: "92A60013-B8D4-403A-BDFB-C3DA4D867B12",
};
